import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Badge } from '../ui/badge';
import { User, MapPin, Calendar, Check } from 'lucide-react';
import { PaymentSection } from './PaymentSection';

export const CheckoutForm = ({
  formData, setFormData, handleSubmit, selectedModality, schedules,
  paymentProps,
}) => (
  <Card className="bg-zinc-900 border-zinc-800">
    <CardHeader>
      <CardTitle className="text-white">Dados da Matrícula</CardTitle>
    </CardHeader>
    <CardContent>
      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Dados Pessoais */}
        <div>
          <h3 className="text-white font-semibold mb-4 flex items-center">
            <User className="mr-2 text-red-500" size={20} />
            Dados Pessoais
          </h3>
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <Label className="text-white">Nome Completo *</Label>
              <Input
                value={formData.full_name}
                onChange={(e) => setFormData({ ...formData, full_name: e.target.value })}
                className="bg-zinc-800 text-white border-zinc-700 mt-2"
                required
              />
            </div>
            <div>
              <Label className="text-white">CPF/CNPJ *</Label>
              <Input
                value={formData.document}
                onChange={(e) => setFormData({ ...formData, document: e.target.value })}
                placeholder="000.000.000-00"
                className="bg-zinc-800 text-white border-zinc-700 mt-2"
                required
              />
            </div>
            <div>
              <Label className="text-white">Email *</Label>
              <Input
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                className="bg-zinc-800 text-white border-zinc-700 mt-2"
                required
              />
            </div>
            <div>
              <Label className="text-white">Telefone *</Label>
              <Input
                value={formData.phone}
                onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                placeholder="(00) 00000-0000"
                className="bg-zinc-800 text-white border-zinc-700 mt-2"
                required
              />
            </div>
            <div className="md:col-span-2">
              <Label className="text-white">WhatsApp * (para grupo da turma)</Label>
              <Input
                value={formData.whatsapp}
                onChange={(e) => setFormData({ ...formData, whatsapp: e.target.value })}
                placeholder="(00) 00000-0000"
                className="bg-zinc-800 text-white border-zinc-700 mt-2"
                required
              />
            </div>
          </div>
        </div>

        {/* Endereço */}
        <div>
          <h3 className="text-white font-semibold mb-4 flex items-center">
            <MapPin className="mr-2 text-red-500" size={20} />
            Endereço
          </h3>
          <div className="grid md:grid-cols-2 gap-4">
            <div className="md:col-span-2">
              <Label className="text-white">Endereço *</Label>
              <Input
                value={formData.address}
                onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                className="bg-zinc-800 text-white border-zinc-700 mt-2"
                required
              />
            </div>
            <div>
              <Label className="text-white">Cidade *</Label>
              <Input
                value={formData.city}
                onChange={(e) => setFormData({ ...formData, city: e.target.value })}
                className="bg-zinc-800 text-white border-zinc-700 mt-2"
                required
              />
            </div>
            <div>
              <Label className="text-white">Estado *</Label>
              <Input
                value={formData.state}
                onChange={(e) => setFormData({ ...formData, state: e.target.value })}
                placeholder="SP"
                maxLength={2}
                className="bg-zinc-800 text-white border-zinc-700 mt-2"
                required
              />
            </div>
            <div>
              <Label className="text-white">CEP *</Label>
              <Input
                value={formData.postal_code}
                onChange={(e) => setFormData({ ...formData, postal_code: e.target.value })}
                placeholder="00000-000"
                className="bg-zinc-800 text-white border-zinc-700 mt-2"
                required
              />
            </div>
          </div>
        </div>

        {/* Seleção de Turma */}
        {(selectedModality === 'ead_live' || selectedModality === 'presential') && (
          <div>
            <h3 className="text-white font-semibold mb-4 flex items-center">
              <Calendar className="mr-2 text-red-500" size={20} />
              Escolha sua Turma
            </h3>
            <div className="space-y-3">
              {schedules.length > 0 ? (
                schedules.map((schedule) => (
                  <label
                    key={schedule.id}
                    className={`block p-4 border-2 rounded-lg cursor-pointer transition-all ${
                      formData.schedule_id === schedule.id.toString()
                        ? 'border-red-500 bg-red-500/10'
                        : 'border-zinc-700 bg-zinc-800 hover:border-red-500/50'
                    }`}
                  >
                    <input
                      type="radio"
                      name="schedule"
                      value={schedule.id}
                      checked={formData.schedule_id === schedule.id.toString()}
                      onChange={(e) => setFormData({ ...formData, schedule_id: e.target.value })}
                      className="sr-only"
                    />
                    <div className="flex items-center justify-between">
                      <div className="flex-1">
                        <div className="text-white font-semibold">{schedule.class_name}</div>
                        <div className="text-sm text-gray-400 mt-1">
                          Início: {new Date(schedule.start_date).toLocaleDateString('pt-BR')}
                        </div>
                        <div className="text-sm text-gray-400">
                          Instrutor: {schedule.instructor}
                        </div>
                      </div>
                      <div className="text-right">
                        <Badge className={schedule.status === 'open' ? 'bg-green-600' : 'bg-red-600'}>
                          {schedule.enrolled_count}/{schedule.max_students} vagas
                        </Badge>
                      </div>
                    </div>
                  </label>
                ))
              ) : (
                <div className="text-center text-gray-400 p-4 bg-zinc-800 rounded-lg">
                  <p>Novas turmas em breve!</p>
                </div>
              )}
            </div>
          </div>
        )}

        {selectedModality === 'ead_recorded' && (
          <div className="bg-green-900/20 border border-green-500/30 rounded-lg p-4">
            <h3 className="text-green-400 font-semibold mb-2 flex items-center">
              <Check className="mr-2" size={20} />
              Modalidade EaD Gravado
            </h3>
            <p className="text-sm text-gray-300">
              Acesso imediato! Você terá acesso vitalício a todas as aulas gravadas e poderá estudar no seu próprio ritmo, quando e onde quiser.
            </p>
          </div>
        )}

        <PaymentSection {...paymentProps} />
      </form>
    </CardContent>
  </Card>
);

export default CheckoutForm;
